import PropTypes from 'prop-types';
import Skeleton from 'wsm-skeleton';

export const TotalReviewSkeleton = ({isMobile= false}) => {
    return <Skeleton width={isMobile ? '80px' : '100px'} height={isMobile ? '20px' : '24px'} />
}

export default TotalReviewSkeleton;

TotalReviewSkeleton.propTypes = {
    isMobile: PropTypes.bool
};